import React from "react";
import { Button, ButtonProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";

interface ContainedButtonProps extends ButtonProps {
  children: React.ReactNode;
}

const CustomContainedButton = styled(Button)<{ themeDetails?: any }>(({ theme, themeDetails }) => ({
  borderRadius: "6px",
  padding: "10px 20px",
  height: "40px",
  userSelect: "none",
  verticalAlign: "middle",
  textDecoration: "none",
  fontFamily: `Inter, sans-serif`,
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "100%",
  letterSpacing: "-1px",
  fontSize: "18px",
  textTransform: "none",
  minWidth: "64px",
  background: "var(--Header-Bg-Dark-cyan-blue-Color, #4598A6)",
  color: "white", 
  "&.Mui-disabled": {
    background: theme.palette.action.disabledBackground,
    color: theme.palette.action.disabled,
    cursor: "not-allowed",
    pointerEvents: "auto",  
  },
}));

const ContainedButton: React.FC<ContainedButtonProps> = (props) => {
  const themeDetails = useSelector((state: RootState) => state?.themes);

  return (
    <CustomContainedButton variant="contained" themeDetails={themeDetails} {...props}>
      {props.children}
    </CustomContainedButton>
  );
};

export default ContainedButton;
